// extracted by mini-css-extract-plugin
export default {"adminTableStyles":"wEegV___ThreeDContent-module__adminTableStyles"};